import { render, staticRenderFns } from "./AnimText.vue?vue&type=template&id=9855c7b4&"
import script from "./AnimText.vue?vue&type=script&lang=js&"
export * from "./AnimText.vue?vue&type=script&lang=js&"
import style0 from "./AnimText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports